export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.225 2.695l.223.039.136.038c.315.101.589.286.805.422l8.646 5.46A1.002 1.002 0 0121.5 10.5H20V19h2v2H2v-2h2v-8.5H2.5a1 1 0 01-.534-1.846l8.646-5.46c.247-.155.57-.375.941-.46.22-.051.448-.064.672-.039zM6 10.5V19h5v-8.5H6zm7 0V19h5v-8.5h-5zm-1.005-5.807c-.064.035-.15.088-.315.192L5.956 8.5h12.088l-5.723-3.615a6.741 6.741 0 00-.315-.192L12 4.689l-.005.004z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};